






































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Product } from "@/data/productCategory/product/product";
import { Paper } from "@/data/productCategory/product/paper/paper";

import * as def from "@/definitions";
@Component({
  components: {
  }
})
export default class RightController extends Vue {
    @Prop()
    private selectedPaper!: Paper;
    @Prop()
    private selectedProduct!: Product;


    private goNext(readTableFile : boolean)
    {
        this.$emit("doCommand", "goNext", { readTableFile : readTableFile });
    }
    
    //-----ボタン色-----//
    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
